import React from "react";
import {Heading} from "@unibuddy/patron";

export function LoginHeader({title}: {title: string}) {
    return (
        <Heading level="1" size="xxsmall" weight="400">
            {title}
        </Heading>
    );
}
